<template>
    <div v-if="showTravelLeisure">
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                <span id="banking__1">Travel & Leisure</span>
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                <span id="banking__2">Travel & Leisure - Credit/Debit</span>
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Debit Card Mentioned:
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            <span v-if="travel_debit_card_mentioned == 1"> Yes</span>
            <span v-else> NO</span>
            
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Credit Card Mentioned:
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
             <span v-if="travel_credit_card_mentioned == 1"> Yes</span>
            <span v-else> NO</span>
                
            </v-col>
        </v-row>
        <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">
                Credit Network:
            </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
            {{travel_credit_network}}
              
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'TravelLeisure',
    props : [
        "showTravelLeisure",
        'sector',
        'category',
    ],
    data: () => ({
        // card_type_options: [{text:'Select One',value:''},{text:'Visa',value:1},{text:'MasterCard',value:2},{text:'American Express',value:3},{text:'Discover',value:4},{text:'Diners Club',value:5}]
        // travel_debit_card_mentioned: '',
        // travel_credit_card_mentioned: '',
        // travel_credit_network: '',
    }),
    watch: {
        // travel_debit_card_mentioned: function(o) {
        //     this.$emit('travel_debit_card_mentioned', o)
        // },
        // travel_credit_card_mentioned: function(o) {
        //     this.$emit('travel_credit_card_mentioned', o)
        // },
        // travel_credit_network: function(o) {
        //     this.$emit('travel_credit_network', o)
        // },
    },
    computed: {
        ...mapGetters({
            //sector: 'ProductData/getSector',
            all_card_types: 'ProductData/getAllCardTypes',
        }),
        travel_debit_card_mentioned: {
            get: function() {
                return this.$store.getters['ProductData/get_travel_debit_card_mentioned']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_travel_debit_card_mentioned', o)
            }
        },
        travel_credit_card_mentioned: {
            get: function() {
                return this.$store.getters['ProductData/get_travel_credit_card_mentioned']
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_travel_credit_card_mentioned', o)
            }
        },
        travel_credit_network: {
            get: function() {
                 if(this.$store.getters["ProductData/get_travel_credit_network"].length>0){
                    const newar = new Array()
                    let name_el = ''
                    for (let resp in this.$store.getters["ProductData/get_travel_credit_network"]){
                        name_el = this.all_card_types.find(travel_credit_network =>travel_credit_network.value === this.$store.getters["ProductData/get_travel_credit_network"][resp]).text
                        newar.push(name_el) 
                    }
                    return newar.join();

                }else{
                return ""
                }   
                
            },
            set: function(o) {
                this.$store.dispatch('ProductData/set_travel_credit_network', o)
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@import './../../assets/sass/product/banking'
</style>